<template>
  <div class="standard-setting" v-loading="isLoading">
    <!-- <div class="header"></div> -->
    <div class="table" v-loading="publishSurveyLoading">
      <!-- 调查表基础信息 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="问题类型" prop="questionType">
          <el-select v-model="ruleForm.questionType" placeholder="请选择" @change="questionTypeChange">
            <el-option v-for="item in teacherTypeOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="启用状态" prop="status">
          <el-switch v-model="ruleForm.status"></el-switch>
        </el-form-item> -->
      </el-form>
      <el-divider></el-divider>
      <!-- 调查表问题列表 -->
      <el-form v-for="(item, index) in questionList" :key="index" v-if="item.delFlag == 0" label-width="100px"
        class="question-list">
        <div class="delete" @click="delQuestion(item, index)">
          删除<i class="el-icon-delete"></i>
        </div>
        <el-form-item :label="index + 1 + '.问题标题'" :label-position="labelPosition" required>
          <el-input type="textarea" :rows="6" v-model="item.questionDesc"></el-input>
        </el-form-item>
        <!-- <el-form-item label="说明">
          <el-input type="textarea" v-model="item.questionDesc"></el-input>
        </el-form-item> -->
        <el-form-item label="评价要素" :label-position="labelPosition" required>
          <el-select v-model="item.evaluativeFeature" placeholder="请选择">
            <el-option v-for="option in evaluativeFeatureOptions" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顺序" :label-position="labelPosition" required>
          <el-input v-model="item.questionOrder"></el-input>
        </el-form-item>
        <div class="option-list">
          <div class="option-item" v-for="(oItem, oIndex) in item.teacherEvaluationOptions" :key="oIndex">
            {{ oIndex + 1 }}.
            <el-input class="option-content" v-model="oItem.optionDesc" type="optionContent" placeholder="请输入选项名称" />
            <el-input v-model="oItem.score" type="optionContent" placeholder="请输入分数" />
            <i class="el-icon-remove-outline" @click="delOption(item, oIndex)"></i>
          </div>
        </div>
        <div class="add-option" @click="addOption(item)">
          <el-button type="text" icon="el-icon-circle-plus-outline">添加选项</el-button>
        </div>
        <el-divider></el-divider>
      </el-form>
    </div>
    <div class="btn-list">
      <el-button type="primary" @click="addProblem">添加问题</el-button>
      <!-- <el-button type="primary" @click="delProblem">移除问题</el-button> -->
      <el-button type="primary" @click="previewClick('ruleForm')">预览</el-button>
      <el-button type="primary" @click="submit('ruleForm')">保存</el-button>
    </div>
    <previewDialog v-show="previewDialogVisible" :previewDialogVisible.sync="previewDialogVisible" :ruleForm="ruleForm"
      :questionList="questionList" ref="previewDialog" />
  </div>
</template>

<script>
import previewDialog from "./components/preview-dialog/previewDialog.vue";
export default {
  components: {
    previewDialog,
  },
  data() {
    return {
      // 发布加载状态
      publishSurveyLoading: false,
      // 预览弹窗
      previewDialogVisible: false, // 预览弹窗
      // 问题列表
      questionList: [],
      // 加载状态
      isLoading: false,
      // 标签位置
      labelPosition: "left",
      // 表单数据
      ruleForm: {
        questionType: "", // 问题类型
        status: false, // 是否启用
      },
      // 表单规则
      rules: {
        questionType: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],
      },
      teacherTypeOptions: [{
        value: '0',
        label: '班主任'
      }, {
        value: '1',
        label: '科任老师'
      }],
      evaluativeFeatureOptions: [],
    };
  },
  created() {
    this.getTeacherType();
    this.getEvaluativeFeature();
  },
  methods: {
     // 获取评价要素
    getEvaluativeFeature() {
      this.get(`${this.$url.getDictType}/sc_evaluative_feature`).then((res) => {
        this.evaluativeFeatureOptions = res.data;
      });
    },
    // 获取教师类型
    getTeacherType() {
      this.get(`${this.$url.getDictType}/sc_question_teacher_type`).then((res) => {
        this.teacherTypeOptions = res.data;
        // 默认选中第一个值
        if (res.data && res.data.length > 0) {
          this.ruleForm.questionType = res.data[0].dictValue;
          this.getTeacherEvaluation();
        }
      });
    },
    // 删除问题
    delQuestion(item, index) {
      this.$confirm("是否删除当前问题", "删除教评问题", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          item.delFlag = 1;
          // this.questionList.splice(index, 1);
          // console.log("this.questionList:", this.questionList);
        })
        .catch(() => { });
    },
    // 选择类型获取教评问题列表
    questionTypeChange(e) {
      this.getTeacherEvaluation();
    },
    getTeacherEvaluation() {
      let data = {
        schoolId: this.user.schoolId,
        questionType: this.ruleForm.questionType,
      };
      this.get(this.$url.selectTeacherEvaluation, data).then(res => {
        // console.log("查询指定类型教评问题列表==>", res);
        this.questionList = res.data;
      })
    },
    // 提交表单
    submit(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 检查问题列表是否为空
          if (!this.questionList.length)
            return this.$message.warning("请添加问题");
          // 检查是否补充完整
          const someAreNotEmpty = this.checkEmptyValues(this.questionList);

          if (!someAreNotEmpty) {
            return this.$message.warning("请补充完整信息");
          }

          // 将加载状态修改为true
          this.publishSurveyLoading = true;

          // 获取表单数据
          let { questionType, status } =
            this.ruleForm;

          let data = [];
          // data中的数据去除空格符
          data = this.questionList.map((question) => ({
            id: question.id ? question.id : "",
            questionType,
            evaluativeFeature: question.evaluativeFeature,
            schoolId: this.user.schoolId,
            schoolName: this.user.schoolName,
            ...question,
            questionDesc: question.questionDesc.replace(/\s/g, ""),
            // questionDesc: question.questionDesc.replace(/\s/g, ""),
            teacherEvaluationOptions: question.teacherEvaluationOptions.map(
              (surveyQuestion) => ({
                ...surveyQuestion,
                optionDesc: surveyQuestion.optionDesc.replace(
                  /\s/g,
                  ""
                ),
              })
            ),
          })),

            // console.log("data:", data);

            // 发送请求
            this.post(this.$url.insetTeacherEvaluation, data).then((res) => {
              // console.log("添加教师评价标准==》", res);
              // 判断请求是否成功
              if (res.code !== 200) return this.$message.error(res.msg);

              // 添加成功，提示成功信息
              this.$message.success(res.msg);
              // 将加载状态修改为false
              this.publishSurveyLoading = false;

              // 清空表单数据
              // this.ruleForm = {
              //   questionType: "", // 问题类型
              //   status: false, // 是否启用
              // };
              // this.questionList = [];

              // setTimeout(() => {
              //   this.$refs['ruleForm'].clearValidate();
              // }, 1000);
            });
        } else {
          return false;
        }
      });
    },
    previewClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.questionList.length)
            return this.$message.warning("请添加问题");
          const someAreNotEmpty = this.checkEmptyValues(this.questionList);

          if (!someAreNotEmpty) {
            return this.$message.warning("请补充完整信息");
          }

          let questionList = JSON.parse(JSON.stringify(this.questionList));
          // 假设 this.questionList 是一个包含数据的数组
          this.$refs.previewDialog.questionList = questionList.sort((a, b) => {
            // 将 sequence 字符串转换为数值进行比较
            const sequenceA = parseInt(a.questionOrder);
            const sequenceB = parseInt(b.questionOrder);

            // 如果转换失败，使用默认字符串比较
            const compareA = isNaN(sequenceA) ? a.questionOrder : sequenceA;
            const compareB = isNaN(sequenceB) ? b.questionOrder : sequenceB;

            // 返回比较结果
            return compareA - compareB;
          });

          this.previewDialogVisible = true;
        } else {
          return false;
        }
      });
    },
    // 检测对象数组中是否有属性值为空
    checkEmptyValues(list) {
      // console.log(list);
      for (const item of list) {
        for (const key in item) {
          if (
            key !== "delFlag" && key !== "val"
          ) {
            if (item.hasOwnProperty(key) && !item[key]) {
              return false;
            }
          }
        }
      }
      return true;
    },
    addProblem() {
      if (this.ruleForm.questionType == "") return this.$message.warning("请先选择问题类型");
      // 默认选中第一个评价要素
      const defaultEvaluativeFeature = this.evaluativeFeatureOptions.length > 0 ? this.evaluativeFeatureOptions[0].dictValue : "";
      this.questionList.push({
        questionOrder: "", // 顺序
        questionDesc: "",
        evaluativeFeature: defaultEvaluativeFeature, // 评价要素
        delFlag: 0, // 是否删除 0：不删 1：删除
        val: "", // 用于预览时的选择绑定值
        teacherEvaluationOptions: [],
      });
    },
    delProblem() {
      if (this.questionList.length <= 1)
        return this.$message.warning("已到最小限制数,请勿点击删除");
      this.questionList.pop();
      this.$notify({
        type: "success",
        title: "删除表单问题",
        message: "删除成功",
        position: "bottom-right",
      });
    },
    // 问题类型为单选多选下拉时点击添加选项
    addOption(item) {
      item.teacherEvaluationOptions.push({
        optionDesc: "",
        score: "",
        optionOrder: item.teacherEvaluationOptions.length + 1,
      });
    },
    delOption(item, index) {
      item.teacherEvaluationOptions.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./standardSetting.scss";
</style>
